import React,{useState,useEffect} from "react";
const InfoBar = ({jsonFileName, greyValue }) => {  // jsonFileName：记录核团名-灰度值键值对的json文件名；greyValue：待检索的灰度值
    
    const [structureList, setStructureList] = useState([]); // 核团名-灰度值键值对
    useEffect(() => {
        fetch(jsonFileName)
            .then(response => response.json())
            .then(data => {
                setStructureList(data);
            })
            .catch(error => {
                console.error("Error fetching data.json:", error);
            });
    }, []);

    // 根据灰度值匹配核团名
    const findStructureByGreyValue = (num) => {
        if (structureList[num]) {
            return structureList[num]
        } else {
            return ''
        }
    }
    const label = `Structure Name: ${findStructureByGreyValue(greyValue)}`
    
    return (<div id='info'><div id='label'>{label}</div></div>)
}
export default InfoBar;